export * from './only-number.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/only-number/index.ts